<template>
  <v-card elevation="0">
    <v-card-text class="pa-0">
      <!-- Rule Builder Row -->
      <v-row align="center" class="mb-2">
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="activeTerminal.type"
            :items="types"
            item-text="value"
            item-value="key"
            :label="$t('label.type') || 'Type'"
            outlined
            dense
            hide-details
            clearable
          />
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="activeTerminal.value"
            :items="selectedType || []"
            item-text="name"
            item-value="id"
            :label="$t('label.value') || 'Value'"
            outlined
            dense
            hide-details
            clearable
            :disabled="!activeTerminal.type"
          />
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="activeTerminal.terminal"
            :items="terminals"
            item-text="name"
            item-value="id"
            :label="$t('label.terminal') || 'Terminal'"
            outlined
            dense
            hide-details
            clearable
          />
        </v-col>

        <v-col cols="12" sm="6" md="3" class="d-flex align-center">
          <v-btn
            color="primary"
            :disabled="!addable"
            @click="addTerminal"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ $t('button.add') || 'Add' }}
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4" />

      <!-- Empty state -->
      <v-alert
        type="info"
        text
        dense
        border="left"
      >
        {{ $t('setting.print_terminals.no_rules') || 'No print routing rules configured.' }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SalesPrintTerminals',
  components: {},
  data () {
    return {
      types: [{ key: 'item', value: 'Item' }, { key: 'family', value: 'Family' }, { key: 'dept', value: 'Department' }],
      terminals: [{ id: 1, name: 'POS Kitchen', ip: '192.168.3.1', shared: '' }, {
        id: 2,
        name: 'POS Stock Controller',
        ip: '192.168.3.3',
        shared: 'slm-stock-pos-printer'
      }],
      items: [],
      families: [],
      departments: [],
      activeTerminal: {
        type: null,
        value: null,
        terminal: null
      }
    }
  },
  watch: {
    'activeTerminal.type' (value) {
      if (this.activeTerminal.value) this.activeTerminal.value = null
    }
  },
  computed: {
    addable () {
      return !Object.values(this.activeTerminal).some(value => value === null)
    },
    selectedType () {
      switch (this.activeTerminal.type) {
        case 'item':
          return this.items
        case 'family':
          return this.families
        case 'dept':
          return this.departments
        case 'cat':
          return this.categories
      }
    }
  },
  methods: {
    async fetchCategoryTypes () {
      this.families = await this.$categoryService.getCategories()
      this.items = await this.$itemService.getActiveItems()
      this.departments = await this.$departmentService.getDepartments()
    },
    addTerminal () {
      // TODO: implement add terminal rule
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('setting.tabs.sales_print_terminals') || 'Print Terminals')
    this.fetchCategoryTypes()
  }
}
</script>
